module.exports = __webpack_public_path__ + "img/wordmap.aec1a920.png";